// the "routeless" version should only be used for non-inline modals
import routeless from "metabase/hoc/Routeless";
import { FullPageModal } from "metabase/components/Modal/FullPageModal";

export const RoutelessFullPageModal = routeless(FullPageModal);
